import classNames from 'classnames';
import { NormalButton } from '@/shared/ui/components';
import './style.scss';
import type { PatientNameFormatterProps } from './patientNameFormatter.types';

const PatientNameFormatter = ({
  patientId = '',
  patientName,
  handleClickPatientName,
}: PatientNameFormatterProps) => (
  <div className={classNames('flex items-center', patientId && 'patient-name-and-id-format')}>
    <NormalButton
      id="patient-name-formatter-btn"
      isText
      buttonName={patientName}
      onClick={handleClickPatientName}
    />
    {patientId && <div>{`ID: ${patientId}`}</div>}
  </div>
);

export default PatientNameFormatter;
